module.exports = __webpack_public_path__ + "img/worknet2.e12088e9.jpg";